import { useRouter } from "next/router";

const useProductDetailQueryParams = () => {
  const router = useRouter();
  const { query } = router;

  const slug = typeof query.slug === "string" ? query.slug : "";
  const source = typeof query.source === "string" ? query.source : "";
  const source_slug = typeof query.source_slug === "string" ? query.source_slug : "";
  const section = typeof query.section === "string" ? query.section : "";
  const source_entity = typeof query.source_entity === "string" ? query.source_entity : "";
  const section_entity = typeof query.section_entity === "string" ? query.section_entity : "";
  const section_slug = typeof query.section_slug === "string" ? query.section_slug : "";
  const q = typeof query.q === "string" ? query.q : "";

  return {
    slug,
    source,
    source_slug,
    section,
    source_entity,
    section_entity,
    section_slug,
    q,
  };
};

export default useProductDetailQueryParams;
